export const ROUTES = {
  LOGIN: `/login`,
  FORGOT_PASSWORD: `/forgot-password`,
  REGISTER: `/register`,
  INDEX: `/`,
  NEW_PASSWORD: `/new-password`,
  VERIFYEMAIL:`/verify-email`,
  REQUESTVERIFY:`/delete-request`,
  DELETEUSER:`/delete-user`,
  DASHBOARD: `/dashboard`,
  DOCTOR: `/doctor`,
  PATIENT: `/patient`,
  PATIENTAPPOINTMENTDETAIL: `/patient/patientAppointment/:formType`,
  ADDDOCTOR: `/doctor/:formType`,
  DOCTORQUESTION: '/doctor/addquestion/:doctorId/:formType',
  VIEWDOCTOR: `/viewdoctor`,
  AVAILABILITY: `/availability`,
  ADDAVAILABILITY: `/availability/addAvailability/:formType`,
  BLOCKAVAILABILITY: `availability/blockAvailability/:formType`,
  AVAILABILITYCALANDER: "availability/slotCalander/:formType",
  APPOINTMENT: `/appiontment`,
  ADDAPPOINTMENT: `/appointment/:formType`,
  MYBANKMANAGEMENT: `/mybankmanagement`,
  MYPROFILE: `/myprofile`,
  CHANGEPASSWORD: `/changepassword`,
  ADDBANKANDCONTRACT: "/add-bank-and-contract",
  JOBPOTSLIST: `/job-requiremnet`,
  ADDJOBPOST: `/job-requiremnet/job-post/:formType`,
  JOBMATCHINGLIST: `/job-requiremnet/job-matching-list/:id`,
  RATING: `/rating`,
  PRIVACYPOLICY: `/privacyandpolicy`,
  RESCHEDULINGPOLICY: `/reschedulingpolicy`,
  CANCELATIONPOLICY: `/cancellationpolicy`,
  TERMSANDCONDITION: `/termsandcondition`,
  PAYMENT: `/payment`,
  ROLE_MANAGEMENT: "/role-management",
  ADDROLE: `/role-management/role/:formType`,
  STAFF: "/role-management/staff",
  ADDSTAFF: "/role-management/staff/:formType",
  SUBSCRIPTION: "/subscription/:clinic",
  PAYMENTSUCCESS: "payment-success"

};
